import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {ConverterService, OccEndpointsService} from "@spartacus/core";
import {Observable} from "rxjs";
import {ImportCsv} from "../interfaces/ImportCsv";

@Injectable({
  providedIn: 'root'
})
export class GonvarriImportCartEntriesAdapter {

  constructor(
    protected http: HttpClient,
    protected occEndpointsService: OccEndpointsService,
  ) {}

  getTemplateFile(): Observable<ImportCsv> {
    return this.http.get<ImportCsv>(this.getTemplateFileUrl(), {})
  }

  postExcelFile(
    excelFile: File
  ): Observable<any> {
    const formData = new FormData();
    formData.append("excelFile", excelFile);
    return this.http.post<ImportCsv>(this.getPostExcelFileUrl(), formData);
  }

  getPostExcelFileUrl(): string {
    return this.occEndpointsService.buildUrl(`/import/csv/saved-cart-excel`);
  }

  getTemplateFileUrl(): string {
    return this.occEndpointsService.buildUrl(`/import/csv/saved-cart`);
  }

}
